import { defineComponent, PropType } from "vue";

import { COMPONENT_NAME, SVG } from "./attributes";

import { SvgAttribute } from "@/shared/constants/constants";
import { ParserParseRequest } from "@/shared/repository/modules/parser/repo";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    document: {
      type: <PropType<ParserParseRequest>>Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      parserRepository: this.$projectServices.parserRepository,
      authRepository: this.$projectServices.authRepository,
    };
  },
  computed: {
    displayedSvg(): SvgAttribute {
      return SVG;
    },

    isDisabled(): boolean {
      return this.isLoading;
    },
  },
  methods: {
    async handleDownload(): Promise<void> {
      try {
        this.isLoading = true;

        const token = await this.authRepository.parseToken();

        await this.parserRepository.parse(this.document, token);
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
});
